import { EstadoPedido, Pedido, TRANSICIONES_VALIDAS } from '../../types/pedido';
import { Button } from '../shared/Button';

interface Props {
  pedido: Pedido;
  onTransicionar: (nuevoEstado: EstadoPedido) => void;
  transicionando: boolean;
}

const ETIQUETA_ACCION: Record<EstadoPedido, string> = {
  PendienteDeConfirmacion: 'Marcar pendiente',
  Confirmado: 'Confirmar pedido',
  EnProceso: 'Marcar en proceso',
  Completado: 'Marcar completado',
  Cancelado: 'Cancelar pedido',
};

/**
 * Solo renderiza botones para transiciones validas segun TRANSICIONES_VALIDAS
 * (espejo de UX) — la validacion real ocurre en el backend (BR-ORD-06/10).
 */
export function EstadoTransitionButtons({ pedido, onTransicionar, transicionando }: Props) {
  const disponibles = TRANSICIONES_VALIDAS[pedido.estado];

  if (disponibles.length === 0) {
    return <p className="text-xs text-admin-ink-muted">Este pedido no admite más transiciones.</p>;
  }

  return (
    <div className="flex flex-wrap gap-3 pt-1.5">
      {disponibles.map((estado) => (
        <Button
          key={estado}
          variante={estado === 'Cancelado' ? 'danger' : 'primary'}
          disabled={transicionando}
          onClick={() => onTransicionar(estado)}
          data-testid={`order-transition-button-${estado}`}
        >
          {ETIQUETA_ACCION[estado]}
        </Button>
      ))}
    </div>
  );
}
